<template>

<core-filter-advanced-group title="Types" :count="count">

	<core-filter-input-suggest placeholder="Start typing a type..." :has-require="true" :toggle="true" field="subdomain_name" :filter="value('subdomains')" api="subdomains/suggest" data="subdomains" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {
			fields: ['subdomains']
		}
	}

}

</script>